module.exports = __webpack_public_path__ + "img/product-banner_8.17e03f04.png";